/* HatShOe productpagina.
   Geen voorgeselecteerde maat, voetlengte en voorraad bij de gekozen maat,
   een verzendbelofte die met de klok meebeweegt, en een sticky bestelbalk.

   Alles is idempotent: applyState leest de huidige DOM en schrijft de UI opnieuw,
   zodat een herrendering door de themascripts niets kapot kan maken.

   De Nederlandse teksten staan bewust niet hier maar in hs-buybox.liquid, in
   het data-eiland onder labels. Zo kan de tekst zich aanpassen aan het
   product: bij een schoen het laatste paar, bij een broek het laatste stuk. */
(function () {
  'use strict';

  /* Terugval als het data-eiland om wat voor reden dan ook geen labels heeft. */
  var FALLBACK = {
    help: 'Kies de maat die je kind normaal draagt. Zit je ertussenin? Neem dan de grotere maat.',
    low: 'Laatste stuk in deze maat',
    stock: 'Op voorraad'
  };

  /* De verzendgrens bepaalt welke belofte er staat. Voor 16:00 op een werkdag
     gaat hij vandaag mee, daarna schuift hij naar de eerstvolgende werkdag.
     Zo staat er na sluitingstijd nooit iets wat niet waargemaakt wordt. */
  var CUTOFF_HOUR = 16;
  var DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

  function parseData() {
    var el = document.querySelector('[data-hs-buybox-data]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function label(data, key) {
    if (data && data.labels && data.labels[key]) return data.labels[key];
    return FALLBACK[key];
  }

  function findForm() {
    return document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function findSubmit() {
    var form = findForm();
    return form ? form.querySelector('.product-form__submit') : null;
  }

  function matchesSize(data, value) {
    if (!data) return false;
    for (var i = 0; i < data.sizes.length; i++) {
      if (String(data.sizes[i].value) === String(value)) return true;
    }
    return false;
  }

  function sizeRecord(data, value) {
    for (var i = 0; i < data.sizes.length; i++) {
      if (String(data.sizes[i].value) === String(value)) return data.sizes[i];
    }
    return null;
  }

  function checkedSizeInput(data) {
    var picker = document.querySelector('variant-selects');
    if (!picker) return null;
    var inputs = picker.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < inputs.length; i++) {
      if (matchesSize(data, inputs[i].value)) return inputs[i];
    }
    return null;
  }

  function setText(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  /* Huidige tijd in Amsterdam, ongeacht waar de bezoeker zit. */
  function amsterdamNow() {
    try {
      return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
    } catch (err) {
      return new Date();
    }
  }

  function cutoffLine() {
    var now = amsterdamNow();
    var day = now.getDay();
    var isWorkday = day >= 1 && day <= 5;
    var cutoff = new Date(now.getTime());
    cutoff.setHours(CUTOFF_HOUR, 0, 0, 0);

    if (isWorkday && now < cutoff) {
      return 'Bestel nu, vandaag verstuurd';
    }

    /* Na de grens of in het weekend: zoek de eerstvolgende werkdag. */
    var ahead = 1;
    var next = new Date(now.getTime());
    next.setDate(next.getDate() + 1);
    while (next.getDay() === 0 || next.getDay() === 6) {
      next.setDate(next.getDate() + 1);
      ahead += 1;
    }
    var when = ahead === 1 ? 'morgen' : DAYS[next.getDay()];
    return 'Bestel nu, ' + when + ' verstuurd';
  }

  function renderCutoff() {
    var box = document.querySelector('[data-hs-cutoff]');
    if (!box) return;
    setText(box.querySelector('[data-hs-cutoff-text]'), cutoffLine());
    box.hidden = false;
  }

  function applyState() {
    var data = parseData();
    if (!data) return;

    var input = checkedSizeInput(data);
    var record = input ? sizeRecord(data, input.value) : null;

    var help = document.querySelector('[data-hs-help]');
    var stock = document.querySelector('[data-hs-stock]');
    var stockText = document.querySelector('[data-hs-stock-text]');

    if (record && record.foot) {
      setText(help, 'Maat ' + record.value + ' past bij een voetlengte van ' + record.foot + '.');
    } else {
      setText(help, label(data, 'help'));
    }

    if (stock) {
      if (record && record.available) {
        var low = record.tracked && record.qty === 1;
        setText(stockText, low ? label(data, 'low') : label(data, 'stock'));
        stock.classList.toggle('hs-buybox__stock--low', low);
        stock.hidden = false;
      } else {
        stock.hidden = true;
      }
    }

    var submit = findSubmit();
    if (submit && !submit.disabled) {
      var btnLabel = submit.querySelector('span');
      if (!record) {
        submit.classList.add('hs-awaiting-size');
        if (btnLabel) setText(btnLabel, 'Kies eerst je maat');
      } else {
        submit.classList.remove('hs-awaiting-size');
        if (btnLabel) setText(btnLabel, 'In winkelmandje, ' + (record.price || data.price));
      }
    }

    var stickyButton = document.querySelector('[data-hs-sticky-button]');
    var stickyPrice = document.querySelector('[data-hs-sticky-price]');
    var stickyTitle = document.querySelector('[data-hs-sticky-title]');
    if (stickyButton) {
      setText(stickyButton, record ? 'In winkelmandje' : 'Kies je maat');
    }
    if (stickyPrice && record && record.price) {
      setText(stickyPrice, record.price);
    }
    if (stickyTitle && record && stickyTitle.dataset.hsBase) {
      setText(stickyTitle, stickyTitle.dataset.hsBase + ', maat ' + record.value);
    }

    renderCutoff();
  }

  function nudgeSizePicker() {
    var fieldset = document.querySelector('.product-form__input--pill');
    if (!fieldset) return;
    fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
    fieldset.classList.add('hs-nudge');
    window.setTimeout(function () {
      fieldset.classList.remove('hs-nudge');
    }, 900);
  }

  function guardSubmit(event) {
    var data = parseData();
    if (!data) return;
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest('form[data-type="add-to-cart-form"]')) return;
    if (checkedSizeInput(data)) return;

    event.preventDefault();
    event.stopPropagation();
    nudgeSizePicker();
  }

  function initSticky() {
    var sticky = document.querySelector('[data-hs-sticky]');
    var submit = findSubmit();
    if (!sticky || !submit || !('IntersectionObserver' in window)) return;

    var title = sticky.querySelector('[data-hs-sticky-title]');
    if (title && !title.dataset.hsBase) {
      title.dataset.hsBase = title.textContent.trim();
    }

    if (sticky.dataset.hsBound === 'true') return;
    sticky.dataset.hsBound = 'true';
    sticky.hidden = false;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { rootMargin: '0px 0px -20% 0px' }
    );
    observer.observe(submit);

    sticky.addEventListener('click', function (event) {
      if (!event.target.closest('[data-hs-sticky-button]')) return;
      var data = parseData();
      if (data && !checkedSizeInput(data)) {
        nudgeSizePicker();
        return;
      }
      var current = findSubmit();
      if (current) current.click();
    });
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = window.requestAnimationFrame(function () {
      pending = null;
      applyState();
      initSticky();
    });
  }

  function scheduleBurst() {
    [0, 120, 350, 700, 1200, 2000].forEach(function (ms) {
      window.setTimeout(function () {
        applyState();
        initSticky();
      }, ms);
    });
  }

  function boot() {
    renderCutoff();
    window.setInterval(renderCutoff, 60000);

    if (!document.querySelector('[data-hs-buybox-data]')) return;

    document.addEventListener('change', function (event) {
      var t = event.target;
      if (t && t.matches && t.matches('variant-selects input[type="radio"]')) scheduleBurst();
    });

    document.addEventListener('submit', guardSubmit, true);

    if ('MutationObserver' in window) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }

    applyState();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
